import { useDispatch, useSelector } from 'react-redux';
import { Matrix3 } from 'three';
import HoveringGhostProbe from '../../HoveringGhostProbe';
import machines from '../../../../machines';
import { selectToolLengthOffset, selectMachine, selectJoints } from '../../../../selectors/machine-state';
import { selectActiveOperation } from '../../../../selectors/probing';
import create from 'zustand';
import actions from '../../../../actions';

export const useAlignHandles = create(set => ({
  handleGroup: null,
  setHandleGroup: (handleGroup) => set({ handleGroup })
}));

export function Align(props) {
  const {
    children
  } = props;

  const {
    handleGroup,
    setHandleGroup
  } = useAlignHandles();

  const dispatch = useDispatch();

  const onSetJoints = (joints) => dispatch(actions.machineState.joints.set(joints));
  const activeOperation = useSelector(selectActiveOperation);
  const onSave = (args) => dispatch(actions.probing.updateOperation({ index: activeOperation, object: { args }})); 

  const toolLengthOffset = useSelector(selectToolLengthOffset);
  const machine = machines[useSelector(selectMachine)];
  const joints = useSelector(selectJoints);
  const toolDirection = machine.toolDirection(joints);

  const clickHandler = (hit) => {
    if(handleGroup) {
      const n = hit.intersections[0].face.normal;
      const obj = hit.intersections[0].object;
      const p = hit.intersections[0].point;

      const mat = handleGroup.matrixWorld.clone().invert(); // mat is world2part matrix

      const newP = p.clone().applyMatrix4(mat);

      const object2part = obj.matrixWorld.clone().premultiply(mat);
      const normMat = new Matrix3();
      normMat.getNormalMatrix(object2part);

      const newN = n.clone().applyNormalMatrix(normMat);

      newP.x += newN.x*2./25.4;
      newP.y += newN.y*2./25.4;
      newP.z += newN.z*2./25.4;

      const orientation = machine.orientationFromToolDirection(newN.x, newN.y, newN.z);
      const rounded = [ Math.round(orientation[0]*1000)/1000, Math.round(orientation[1]*1000)/1000 ];
      if(!hit.shiftKey) {
        const newJoints = machine.inverseFiveAxis({ X: newP.x, Y: newP.y, Z: newP.z, B: rounded[0], C: rounded[1] }, toolLengthOffset);
        const rotaryAxes = [ "A", "B", "C" ];
        const args = {};
        for(let i = 0; i < newJoints.length; i++) {
          if(rotaryAxes.includes(machine.jointLabels[i])) {
            args[machine.jointLabels[i]] = newJoints[i];
          }
        }
        console.log("args", args);
        onSave(args);
        onSetJoints(newJoints);
        
      } else {
        const newJoints = machine.inverseFiveAxis({ X: newP.x, Y: newP.y, Z: newP.z, B: joints[3], C: joints[4] }, toolLengthOffset);
        onSetJoints(newJoints);
      }
    }
  };

  return <group ref={setHandleGroup} onClick={clickHandler}>
  <HoveringGhostProbe toolDirection={toolDirection} alignToNormal={true} show={true}>
  {children}
  </HoveringGhostProbe>
  </group>;
}

export default Align;
